export default "__VITE_ASSET__DtBiA3iZ__"